import { ContextMenuEntity, ContextMenuHolderWrapper, ContextMenuItemEvent } from '@core/models/context-menu.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

export const isContextMenuValueContextEntity = (payload: ContextMenuEntity): payload is ContextMenuHolderWrapper => {
  return 'holder' in payload && payload.holder !== undefined
}

export const getMetricValueAndContext = <T>(
  { value, valueContext }: ContextMenuItemEvent,
  aggregationMode?: Aggregation
) => {
  if (isContextMenuValueContextEntity(valueContext)) {
    return {
      context: valueContext.holder as T,
      value,
      mode: valueContext.overrideAggregationMode || aggregationMode
    }
  }

  return {
    context: valueContext as T,
    value,
    mode: aggregationMode
  }
}
